import React, { useState } from 'react';
import {Link} from 'react-router-dom'
import line from '../assets/Line.png'
import initial from '../assets/initial.png'
import alarm from '../assets/alarm.png'
import "../pages/GoXDashboard/GoXDashboard.css"
import searchIcon from "../assets/searchIcon.png"
import add from '../assets/add.png'
import text from '../assets/text.png'
import all from '../assets/all.png'
import active from '../assets/active.png'
import inactive from '../assets/inactive.png'
import pending from '../assets/pending.png'
import Line from '../assets/Line.png'
import menu from '../assets/menu.png'
import {CiSearch} from 'react-icons/ci';

import './EmployeeFolder/EmployeeFolder.css'
import Table from './Table';
import Employeeconnect from '../pages/Invite/Employeeconnect';


function LeaveManagement() {

  const [showDiv, setShowDiv] = useState(false);
  const [tab, setTab] = useState('')
  const [showOption, setShowOption] = useState(false);
  const [filterOption, setFilterOption] = useState(''); // Add this state for the filter
  const [mode, setMode] = useState('')
  const [option, setOption] = useState('option1')
  const isEmpty = true;
  const [form, setForm] = useState('')
  
  const handleForm =() =>{
    setForm(!form);
  }


  const handleFilterChange = (e) => {
    setFilterOption(e.target.value);
  };

  const toggleDiv = () => {
    setShowDiv(!showDiv);
  };
  
  return (
       <>
        <div className="icon " onClick={toggleDiv}>
          <img src={menu} alt="" />
        </div>
        {showDiv && (
        <div className=" your-div1">
            <div className='employ mt-5 d-flex justify-content-between'>
        <div className='d-flex '>
            <div className='emp'> Leave Management</div>
           
       </div>

        <div className='d-flex ini '>
          <div className='mx-2'><img src={alarm} alt="" /></div>
          <div className='mx-2'><img src={line} alt="" /></div>
          <div><img src={initial} alt="" /></div>
        </div>
  </div>

  <div className='d-flex mx-3 mt-2 activities'>

    <div className='allemploy d-flex m-3'>
      <div><img src={all} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Completed leaves</h6>
        <p><strong>144</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='activeemploy d-flex m-3'>
      <div><img src={active} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Active leaves</h6>
      <p><strong>134</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='inactiveemploy d-flex m-3'>
      <div><img src={inactive} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Pending request</h6>
        <p><strong>10</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='pendingactivation d-flex m-3 '>
      <div><img src={pending} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Decline leaves</h6>
        <p><strong>0</strong></p>
        </div>
     
    </div>


  </div>

  <div className="container mt-3">
      <div className="row justify-content-between">
        <div className="col-md-5">
          <div className="input-group">
            
            <span className="input-group-text">
               <img src={searchIcon} alt="" />
              </span>
            <input
              type="text"
              className="search"
              placeholder="Search"
            />
          </div>
        </div>
   

        <div className="col-md-5">
          <button onClick={() => setShowOption(true)} className="btn  btn-block btn3"> <span><img src={add} alt="" /></span>Create Leave</button>
        </div>
      </div>
    </div>
        </div>
      )}

<div className="your-div your-div2">
            <div className='employ mt-5 d-flex justify-content-between'>
        <div className='d-flex '>
            <div className='emp'> Leave Management</div>
            
       </div>

        <div className='d-flex ini '>
          <div className='mx-2'><img src={alarm} alt="" /></div>
          <div className='mx-2'><img src={line} alt="" /></div>
          <div><img src={initial} alt="" /></div>
        </div>
  </div>

  <div className='d-flex mx-3 mt-2 activities'>

    <div className='allemploy d-flex m-3'>
      <div><img src={all} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Completed leaves</h6>
        <p><strong>144</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='activeemploy d-flex m-3'>
      <div><img src={active} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Active leaves</h6>
      <p><strong>134</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='inactiveemploy d-flex m-3'>
      <div><img src={inactive} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Pending request</h6>
        <p><strong>10</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='pendingactivation d-flex m-3 '>
      <div><img src={pending} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Decline leaves</h6>
        <p><strong>0</strong></p>
        </div>
     
    </div>


  </div>

 



     

      <div className='employee-function-bar'>
        <div>
                  <CiSearch className='search-icon'/>
        <input placeholder='Search' className='input'/>
        </div>

        <div className='employee-button-div'>
          <button className='outline-button'>Export</button>
          <button className="filter-container">
              <select
                id="filterOption"
                value={filterOption}
                onChange={(e) => setFilterOption(e.target.value)}
              >
                <option value="">January</option>
                <option value="febuary" onClick={() => setTab('febuary')}>Febuary</option>
                <option value="march">March</option>
                <option value="april">April</option>
                <option value="may">May</option>
                <option value="june">JUne</option>
                <option value="july">July</option>
                <option value="august">August</option>
                <option value="september">September</option>
                <option value="october">October</option>
                <option value="november">November</option>
                <option value="december">December</option>
              </select>
            </button>
            <button className='filter-container'>
              <select name="" id="filterOption">
                <option value="activeLeaves">Active leaves</option>
                <option value="declinedLeaves">Declined leaves</option>
                <option value="pendingRequest">Pending request</option>
              </select>
            </button>
          <button className='btn6' onClick={() => setShowOption(true)}><span>+</span>Create Leave</button>
        </div>
      </div>

</div>

      {
        tab === 'employees' ? 
    <Table />
     : tab === 'salaries' ? "" : tab === 'suspensions' ? <div>suspensions</div> : <div className="center">
     <div className='small'>
       <div className='text '><img src={text} alt="" /></div>
       <div className='m-4 details'>
         <h6>There are no data entries yet</h6>
         <p>Tap button below add and manage employee leave</p>
       </div>
       <div>
         <button className='btn4 ' onClick={() => setShowOption(true)}><span><img src={add} alt="" /></span>Create New Leave</button>
       </div>
     </div>
</div>  
      }
{/* 
      {
        showOption ?   <div className='position-absolute d-flex top-0 start-0 w-100 h-100 justify-content-center  align-items-center'>
        {
          option === 'option1' ? <div>
              <Employeeconnect setMode={setMode} setOption={setOption}/>
          </div> : mode && option === 'option2' ? <Sendinvite setOption={setOption} setShowOption={setShowOption}/> : option === 'option3' ? <div>
            {
              mode  ? <div><Invitesent setShowOption={setShowOption} setOption={setOption}/></div> : <div><Sendinvite setShowOption={setShowOption}/></div>
            }
          </div> : ''
        }
      </div> : ''
      } */}
    
  

   
  
       
       </>

  
  )
}

export default LeaveManagement